import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import RendererCacheManager from 'next/javascripts/components/table-view/cache';
import { matches } from 'next/javascripts/modules/dom';

const PRIORITY_REGX = /^[!！]+/;
// eslint-disable-next-line no-control-regex
const TAG_REGX = /^[#＃](([^\u0000-\u007F]|\w|\d|\.|-|_)+)[#＃]?/;

Component('tr-project-table-view-todo-title', {
  mixins: [eventListenerMixin],

  properties: {
    url: {
      type: String,
    },

    content: {
      type: String,
    },
  },

  connected() {
    this.listenTo(this.querySelector('.detail-icon'), 'click', (event) => {
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.namespacedTrigger('openpage', { bubbles: true, detail: { url: this.url } });
    });
  },

  disconnected() {
    this.stopListening();
  },

  init() {
    this.renderContent();
  },

  renderContent() {
    const wrapper = document.createDocumentFragment();
    const content = document.createElement('div');
    content.classList.add('content');

    const priority = this.extractPriority();
    if (priority) {
      content.insertAdjacentHTML('beforeend', `<em class="priorty">${priority}</em>`);
    }

    this.extractTags().forEach((tag) => {
      content.insertAdjacentHTML('beforeend', `
        <span class="tag" data-text="${tag}">${tag}</span>
      `);
    });

    content.insertAdjacentHTML('beforeend', `<span class="title">${this.extractTitle()}</span>`);
    wrapper.appendChild(content);

    const icon = document.createElement('i');
    icon.title = '查看任务详情';
    icon.classList.add('twr', 'twr-fullscreen', 'detail-icon');
    wrapper.appendChild(icon);

    this.appendChild(wrapper);
  },

  extractPriority() {
    const matched = this.content.match(PRIORITY_REGX);
    if (matched) {
      return Array.from(matched[0], () => '!').join('');
    }

    return null;
  },

  extractTags() {
    const tags = [];
    let content = this.content.replace(PRIORITY_REGX, '').trim();
    let matched = content.match(TAG_REGX);

    while (matched) {
      tags.push(matched[1].trim());
      content = content.slice(matched[0].length).trim();
      matched = content.match(TAG_REGX);
    }

    return tags;
  },

  extractTitle() {
    let title = this.content.replace(PRIORITY_REGX, '').trim();
    let matched = title.match(TAG_REGX);

    while (matched) {
      title = title.slice(matched[0].length).trim();
      matched = title.match(TAG_REGX);
    }

    return title;
  },
});

export default function (Handsontable) {
  const isDetailListenerAdded = new WeakMap();
  const isBeforeMouseDownHookAdded = new WeakMap();

  function registerDetailClosedEvent(instance) {
    if (!isDetailListenerAdded.has(instance)) {
      const eventManager = new Handsontable.EventManager(instance);

      eventManager.addEventListener(
        instance.rootElement,
        'tr-project-table-view-todo-title:closed',
        (event) => {
          const { row, col } = event.target.dataset;
          instance.selectCell(parseInt(row, 10), parseInt(col, 10));
        },
      );

      eventManager.addEventListener(
        instance.rootElement,
        'tr-project-table-view-todo-title:opened',
        () => instance.deselectCell(),
      );

      isDetailListenerAdded.set(instance, eventManager);
    }
  }

  function addBeforeMouseDownHook(instance) {
    if (!isBeforeMouseDownHookAdded.has(instance)) {
      instance.addHook('beforeOnCellMouseDown', (event) => {
        if (matches(event.target, 'tr-project-table-view-todo-title .detail-icon')) {
          event.stopImmediatePropagation();
        }
      });
      isBeforeMouseDownHookAdded.set(instance, true);
    }
  }

  return function todoTitleRenderer(instance, td, row, column, prop, value, ...args) {
    const cacheManager = new RendererCacheManager(instance, row, column);

    Handsontable.renderers.BaseRenderer.apply(this, [
      instance, td, row, column, prop, value, ...args,
    ]);

    let { element } = cacheManager.cache || {};

    if (!cacheManager.cache || cacheManager.cache.value !== value) {
      element = document.createElement('tr-project-table-view-todo-title');
      element.content = value || '';
      element.dataset.row = row;
      element.dataset.col = column;
    }

    element.url = instance.getDataAtRowProp(row, 'todoUrl') || '';
    if (!element.url) element.removeAttribute('url');
    cacheManager.setCache({ value, element });

    Handsontable.dom.empty(td);
    td.appendChild(element);

    registerDetailClosedEvent(instance);
    addBeforeMouseDownHook(instance);
  };
}
